import React from 'react'
import { Spin, SpinWrapper } from './styles'
import PropTypes from 'prop-types'

export const LoadingSpin = ({ loadingText = 'Loading...' }) => {
  return (
    <SpinWrapper>
      <Spin tip={loadingText} />
    </SpinWrapper>
  )
}

LoadingSpin.propTypes = {
  loadingText: PropTypes.string
}
